export const Types = {
  RETRIEVE_ALL_SUBJECTS_REQUEST: '[subjects]RETRIEVE_ALL_SUBJECTS_REQUEST',
  RETRIEVE_ALL_SUBJECTS_SUCCESS: '[subjects]RETRIEVE_ALL_SUBJECTS_SUCCESS',
  RETRIEVE_ALL_SUBJECTS_FAILURE: '[subjects]RETRIEVE_ALL_SUBJECTS_FAILURE',
  RETRIEVE_SUBJECTS_BY_UNIT_REQUEST: '[subjects]RETRIEVE_SUBJECTS_BY_UNIT_REQUEST',
  RETRIEVE_SUBJECTS_BY_UNIT_SUCCESS: '[subjects]RETRIEVE_SUBJECTS_BY_UNIT_SUCCESS',
  RETRIEVE_SUBJECTS_BY_UNIT_FAILURE: '[subjects]RETRIEVE_SUBJECTS_BY_UNIT_FAILURE',
  RETRIEVE_SUBJECTS_BY_UNIT_RESET: '[subjects]RETRIEVE_SUBJECTS_BY_UNIT_RESET',
};
